import type { OutreachContactKind } from 'fym-shared/src/music24/outreach/types';
import { useTRPCClientAPI, useTRPCMutation } from '../../../../trpc/trpc';
import { useInvalidateOutreach } from './useInvalidateOutreach';

export interface ImportRow {
  name: string;
  email: string;
  kind?: OutreachContactKind | null;
  url?: string | null;
  tags?: string[] | null;
  /** A note of the workspace (the "Add contact" form). */
  notes?: string | null;
}

export interface ImportResult {
  created: number;
  skipped: number;
  suppressed: number;
}

/** `outreach.contacts.import` (frame q3). The rows stay private to the workspace. */
export function useImportContacts(accountId: number) {
  const trpcClient = useTRPCClientAPI();
  const invalidate = useInvalidateOutreach();
  const mutation = useTRPCMutation({
    mutationFn: (input: { rows: ImportRow[]; listUuid: string | null }) =>
      trpcClient.outreach.contacts.import.mutate({
        accountId,
        rows: input.rows,
        listUuid: input.listUuid,
        canContactConfirmed: true,
      }) as Promise<ImportResult>,
    onSuccess: () => invalidate(['contacts', 'lists']),
  });
  return {
    importRows: mutation.mutateAsync,
    isImporting: mutation.isPending,
    error: mutation.error,
    result: mutation.data,
  };
}
